import script from "./base-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./base-checkbox.vue?vue&type=script&setup=true&lang=js"

import "./base-checkbox.vue?vue&type=style&index=0&id=612eeafd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-612eeafd"]])

export default __exports__